import React from 'react';
import { connect } from 'react-redux';

import { loadReports, updateOrte } from './actions/actions';

import App from './App';

type Props = {
  isRehydrated: boolean,
  loadReports: () => void,
  updateOrte: () => void,
};

class Setup extends React.Component {
  props: Props;

  componentDidUpdate(prevProps: Props) {
    if (prevProps.isRehydrated !== this.props.isRehydrated && this.props.isRehydrated === true) {
      this.props.loadReports();
      this.props.updateOrte();
    }
  }
  render() {
    if (!this.props.isRehydrated) return <div>Loading...</div>;

    return <App />;
  }
}

const mapStateToProps = state => ({
  isRehydrated: state._persist.rehydrated, // eslint-disable-line no-underscore-dangle
});

const mapDispatchToProps = dispatch => ({
  loadReports: () => {
    dispatch(loadReports());
  },
  updateOrte: () => {
    dispatch(updateOrte());
  },
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false,
})(Setup);



// WEBPACK FOOTER //
// ./src/js/Setup.js